export default __webpack_public_path__ + "static/media/i_shopping_medium_grey.d2fd95cb.png";